import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { Component, EventEmitter, Output } from '@angular/core';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { BaseEntity, BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { EnumPageDisplayModes, EnumPageEntitySources } from '@m4u-angular/core/framework/sysenums.enum';
import { File } from '@dato-proxy/entities/file.entity';
import { EnumFileTypes } from '@dato-proxy/enums';

class State extends BaseState {
    Files: File[];
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-file-list-dialog',
    templateUrl: './file-list-dialog.component.html',
    styleUrls: ['./file-list-dialog.component.scss']
})
export class FileListDialogComponent extends BasePageComponent<BaseEntity, State> {

    @Output() ShowFile: EventEmitter<File> = new EventEmitter<File>();

    constructor(A: ServiceBagService) {
        super(A, 'FileListDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);
    }

    Show(files: File[]) {
        this.State.Files = files;
        this.ShowDialogShort(() => {});
    }

    OnShowFile(file: File) {
        this.ShowFile.emit(file);
        this.BottomSheetContext && this.BottomSheetContext.dismiss();
    }

    GetIconStyle(FileType: EnumFileTypes): string {
        switch (FileType) {
            case EnumFileTypes.Pdf: return 'mdi mdi-file-pdf-box';
            case EnumFileTypes.Word: return 'mdi mdi-file-word-box';
            case EnumFileTypes.Excel: return 'mdi mdi-file-excel-box';
            case EnumFileTypes.Text: return 'mdi mdi-text-box';
            case EnumFileTypes.Archive: return 'mdi mdi-zip-box';
            case EnumFileTypes.Html: return 'mdi mdi-language-html5';
            case EnumFileTypes.Image: return 'mdi mdi-image';
            case EnumFileTypes.Xml: return 'mdi mdi-xml';
            case EnumFileTypes.Email: return 'mdi mdi-email';
            default: return 'mdi mdi-file';
        }
    }
}
